import { styled } from '@mui/material/styles';
import { Box, Typography, Dialog } from '@mui/material';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    position: 'fixed',
    right: 0,
    top: 100,
    bottom: 0,
    width: '940px',
    height: 'auto',
    margin: 0,
    maxWidth: 'none',
    maxHeight: 'none',
    borderRadius: 0,
    background: 'var(--bg-color)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

export const FixedHeaderWrapper = styled(Box)({
  position: 'sticky',
  top: 0,
  background: '#ffffff',
  zIndex: 10,
  padding: '20px 32px 0',
  flexShrink: 0,
});

export const ContentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: '10px 32px 20px',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#c1c1c1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#a8a8a8',
  },
});

export const HeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: '16px',
  flexShrink: 0,
});

export const TitleBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const TitleTypography = styled(Typography)({
  fontFamily: 'Lufga',
  fontSize: '32px',
  fontWeight: 500,
  lineHeight: '100%',
  color: '#0f52ba',
});

export const CloseIcon = styled(Box)({
  width: '24px',
  height: '24px',
  color: '#75838a',
  cursor: 'pointer',
  fontSize: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    color: '#0b2330',
  },
});

export const ContentBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flexShrink: 0,
});

export const MainContentGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 325px',
  gap: '12px',
  alignItems: 'start',
  flexShrink: 0,
  width: '100%',
  minWidth: 0,
});

export const LeftColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginBottom: '8px',
  width: '100%',
  minWidth: 0,
});

export const RightColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const VendorCreatedRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
});

export const FieldBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const LabelTypography = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '100%',
  color: '#75838a',
});

export const ValueTypography = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '140%',
  color: '#0b2330',
});

export const ApprovalInfoBox = styled(Box)({
  width: '100%',
  border: '1px solid #dfdfdf',
  borderRadius: '8px',
  padding: '8px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  boxSizing: 'border-box',
  minHeight: '160px',
});

export const ApprovalRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  margin: '5px',
  marginBottom: '0px',
});

export const InvoiceSectionBox = styled(Box)({
  width: '100%',
  background: '#FAFAFA',
  borderRadius: '8px',
  padding: '12px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const InvoiceRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
});

export const InvoiceFieldBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flex: 1,
});

export const InvoiceFieldBoxRight = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '8px',
});

export const AmountValueTypography = styled(Typography)({
  fontFamily: "'Outfit', sans-serif",
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '100%',
  color: '#0B2330',
});

export const TotalPaidTypography = styled(Typography)({
  fontFamily: "'Outfit', sans-serif",
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '100%',
  color: '#0B2330',
});

export const TotalBalanceLabel = styled(Typography)({
  fontFamily: "'Outfit', sans-serif",
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '100%',
  color: '#0B2330',
});

export const BalanceLabel = styled(Typography)({
  fontFamily: "'Outfit', sans-serif",
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '100%',
  color: '#F0A34A',
});

export const BalanceValue = styled(Typography)({
  fontFamily: "'Outfit', sans-serif",
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '100%',
  color: '#0B2330',
});

export const PaymentsLink = styled(Typography)<{ disabled?: boolean }>(
  ({ disabled = false }) => ({
    fontFamily: 'Outfit',
    fontSize: '14px',
    fontWeight: 500,
    color: disabled ? 'var(--primary-blue-disabled)' : 'var(--primary-blue)',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    textDecoration: 'underline',
    alignSelf: 'flex-end',
    '&:hover': disabled
      ? {}
      : {
          color: '#0b3d8a',
        },
  })
);

export const NoteSectionBox = styled(Box)({
  width: '100%',
  backgroundColor: '#fafafa',
  borderRadius: '8px',
  padding: '12px',
  boxSizing: 'border-box',
  minWidth: 0,
});

export const NoteLabelTypography = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '100%',
  color: '#75838a',
  marginBottom: '8px',
});

export const NoteValueTypography = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '140%',
  color: '#0b2330',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'normal',
  marginBottom: '8px',
  minWidth: 0,
});

export const ItemsSectionTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 600,
  color: 'var(--primary-navy)',
  marginBottom: '12px',
});

export const ItemsHeaderBox = styled(Box)({
  display: 'flex',
  padding: '8px',
  borderBottom: '1px solid var(--border)',
});

export const ItemsRowBox = styled(Box)({
  display: 'flex',
  padding: '8px',
  borderBottom: '1px solid var(--hover-white)',
  '&:last-child': {
    borderBottom: 'none',
  },
});

export const ItemsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  boxSizing: 'border-box',
  border: '1px solid #d9f1ff',
  borderRadius: 8,
  overflow: 'hidden',
  padding: '2px 0px',
  alignItems: 'stretch',
  flexShrink: 0,
  minHeight: '150px',
});

export const ItemColumn = styled(Typography)<{
  width?: string;
  align?: string;
}>(({ width = 'auto', align = 'left' }) => ({
  fontFamily: 'Outfit',
  fontSize: '12px',
  fontWeight: 400,
  color: 'var(--instructions)',
  width,
  textAlign: align as any,
}));

export const ItemValueColumn = styled(Typography)<{
  width?: string;
  align?: string;
}>(({ width = 'auto', align = 'left' }) => ({
  fontFamily: 'Outfit',
  fontSize: '13px',
  fontWeight: 500,
  color: 'var(--primary-navy)',
  width,
  textAlign: align as any,
}));

export const RejectionNoteSectionBox = styled(Box)({
  backgroundColor: 'var(--inactive-bg)',
  borderRadius: '4px',
  padding: '5px',
  boxSizing: 'border-box',
  marginTop: '8px',
  minHeight: '80px',
});

export const RejectionNoteLabel = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '100%',
  color: 'var(--rejection-text)',
});

export const RejectionNoteText = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '140%',
  color: '#0b2330',
  marginTop: '4px',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
});

export const FieldBoxRight = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '8px',
});
